import React from 'react';
import PropTypes from 'prop-types';
const orderBy = require('lodash/orderBy');
const uuid = require('uuid');
import { Form, InputGroup, Button } from 'react-bootstrap';

const Globals = require('../../../../../app/globals');
const Strings = require('../../../../../app/shared/Strings');
const ActivityActions = require('../../../actions/ActivityActions');
const ActivityStore = require('../../../stores/activity_store_reflux');
const OrganizationActions = require('../../../actions/OrganizationActions');
const AssetUtil = require('../../../util/asset');
import ErrorBox from '../../common/ErrorBox';
import ConfirmModal from '../../modal/ConfirmModal';
import SortableTableClassic from '../../table/SortableTableClassic';
import OrgActMetaTagEditor from './OrgActMetaTagEditor';
import ExpandableWell from '../../common/ExpandableWell';
import { ExportTagsInfo, ImportTagsInfo, DeleteTagWarning } from './OrgMetaTagInfoWarnings';
import SingleAssetInput from '../../common/SingleAssetInput';
import WithOrganizationActivityMetaTagImportChanges from '../../DataHOCs/WithOrganizationActivityMetaTagImportChanges';
import OrgActMetaTagImportChanges from './OrgActMetaTagImportChanges';

const propTypes = {
    className: PropTypes.string,
    orgId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    category: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        display_name: PropTypes.string.isRequired,
        type: PropTypes.oneOf(Object.values(Globals.activity_meta_tag.category_type)).isRequired,
        allow_multiple: PropTypes.bool.isRequired,
        requires_order: PropTypes.bool.isRequired,
    }).isRequired,
    tags: PropTypes.object,
    orgActMetaImportChanges: PropTypes.shape({
        tagsToAdd: PropTypes.array,
        tagsToDelete: PropTypes.array,
        tagsToUpdate: PropTypes.array,
        existingTagsHash: PropTypes.string.isRequired,
    }),
};
const defaultProps = {
    className: '',
    tags: {},
};

class OrgActMetaTagCategoryEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedTagId: null,
            addTagError: null,
            addTagActionId: null,
            deleteTagError: null,
            deleteTagActionId: null,
            updateTagError: null,
            updateTagActionId: null,
            reorderTagError: null,
            reorderTagActionId: null,
            tagToDelete: null,
            newTag: '',
            importTagsActionId: null,
            importTagsError: null,
        };

        this.onAddTag = this.onAddTag.bind(this);
        this.onDeleteTag = this.onDeleteTag.bind(this);
        this.onUpdateNewTag = this.onUpdateNewTag.bind(this);
        this.setConfirmDeleteTagModalState = this.setConfirmDeleteTagModalState.bind(this);
        this.onActiveTagClick = this.onActiveTagClick.bind(this);
        this.onUpdateTag = this.onUpdateTag.bind(this);
        this.onReorder = this.onReorder.bind(this);
        this.onDeselectTag = this.onDeselectTag.bind(this);
        this.getExportCsvHref = this.getExportCsvHref.bind(this);
        this.importCsv = this.importCsv.bind(this);
        this.unsubscribes = [
            ActivityStore.listen(this.onActivityStoreChange.bind(this))
        ];
    }

    UNSAFE_componentWillReceiveProps(nextProps) {        
        if (nextProps.organizationStoreAction.id === this.state.importTagsActionId) {
            this.setState({
                importTagsActionId: null,
                importTagsError: nextProps.organizationStoreAction.error || null,
            });
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onActivityStoreChange(newState) {
        if (newState.action.id === this.state.addTagActionId) {
            let updatedState = { addTagActionId: null };

            if (newState.action.error) {
                updatedState = { ...updatedState, addTagError: newState.action.error };
            }
            else {
                updatedState = { ...updatedState, newTag: '', addTagError: null };
            }

            this.setState(updatedState);
        }
        else if (newState.action.id === this.state.deleteTagActionId) {
            let updatedState = {
                deleteTagActionId: null,
                confirmDeleteTagModal: false,
                tagToDelete: null,
            };

            if (newState.action.error) {
                updatedState = { ...updatedState, deleteTagError: newState.action.error };
            }
            else {
                updatedState = { ...updatedState, selectedTagId: null, deleteTagError: null };
            }

            this.setState(updatedState);
        }
        else if (newState.action.id === this.state.updateTagActionId) {
            let updatedState = {
                updateTagActionId: null,
            };

            if (newState.action.error) {
                updatedState = { ...updatedState, updateTagError: newState.action.error };
            }
            else {
                updatedState = { ...updatedState, updateTagError: null };
            }

            this.setState(updatedState);
        }
        else if (newState.action.id === this.state.reorderTagActionId) {
            let updatedState = {
                reorderTagActionId: null,
            };

            if (newState.action.error) {
                updatedState = { ...updatedState, reorderTagError: newState.action.error };
            }
            else {
                updatedState = { ...updatedState, reorderTagError: null };
            }

            this.setState(updatedState);
        }
    }

    onAddTag() {
        const addTagActionId = uuid.v4();
        this.setState({ addTagActionId: addTagActionId }, () => {
            ActivityActions.addOrgActMetaTag(
                addTagActionId,
                {
                    orgId: this.props.orgId,
                    categoryId: this.props.category.id,
                    tag: this.state.newTag,
                }
            );
        });
    }

    onUpdateNewTag(e) {
        this.setState({ newTag: e.target.value });
    }

    onDeleteTag(tagId) {
        const deleteTagActionId = uuid.v4();
        this.setState({ deleteTagActionId: deleteTagActionId }, () => {
            ActivityActions.deleteActMetaTag(
                deleteTagActionId,
                {
                    orgId: this.props.orgId,
                    categoryId: this.props.category.id,
                    tagId: tagId,
                }
            );
        });
    }

    setConfirmDeleteTagModalState(showBool, tagToDelete) {
        this.setState({ confirmDeleteTagModal: showBool, tagToDelete: showBool ? tagToDelete : null });
    }

    onActiveTagClick(e, tagId) {
        let additionalState = {};
        if (tagId !== this.state.selectedTagId) {
            additionalState = {
                updateTagActionId: null,
                updateTagError: null,
                reorderTagActionId: null,
                reorderTagError: null,
            };
        }

        this.setState({ ...additionalState, selectedTagId: tagId });
    }

    onDeselectTag() {
        this.setState({
            selectedTagId: null,
            updateTagActionId: null,
            updateTagError: null,
            reorderTagActionId: null,
            reorderTagError: null,
        });
    }

    onUpdateTag(tagRecord, newTagName) {
        const updateTagActionId = uuid.v4();
        this.setState({ updateTagActionId: updateTagActionId }, () => {
            ActivityActions.updateActMetaTag(
                updateTagActionId,
                {
                    orgId: this.props.orgId,
                    tagId: tagRecord.id,
                    tag: newTagName,
                }
            );
        });
    }

    onReorder(tagRecord, newOrder) {
        const reorderTagActionId = uuid.v4();
        this.setState({ reorderTagActionId: reorderTagActionId }, () => {
            ActivityActions.reorderActMetaTag(
                reorderTagActionId,
                {
                    orgId: this.props.orgId,
                    tagId: tagRecord.id,
                    displayOrder: newOrder,
                }
            );
        });
    }

    getExportCsvHref() {
        return `/authoring/organization/${this.props.orgId}/activity_tags/${this.props.category.id}/csv`;
    }

    importCsv(params, files) {
        const importTagsActionId = uuid.v4();
        this.setState({ importTagsActionId: importTagsActionId }, () => {
            params = {
                ...params,
                orgId: this.props.orgId,
                categoryId: this.props.categoryId,
            };

            OrganizationActions.importActMetaTagsCsv(importTagsActionId, params, files);
        });
    }

    render() {
        const tableColumns = [
            {
                displayName: Strings['en'].act_meta_tags.TAG_NAME,
                key:'tag',
                size: 2,
                type: 'string',
                caseSensitive: true,
            },
            {
                displayName: 'Attached Activities',
                key: 'usage_count',
                size: 1,
                type: 'number',
            },
            {
                displayName: 'Created At',
                key:'created_at',
                size: 3,
                type: 'date'
            }
        ];

        let defaultSort;
        if (this.props.category.requires_order) {
            tableColumns.unshift({
                displayName: Strings['en'].act_meta_tags.DISPLAY_ORDER,
                key: 'display_order',
                size: 1,
                type: 'number',
            });
            defaultSort = { key: 'display_order', type: 'number', asc: true };
        }
        else {
            defaultSort = { key: 'tag', type: 'string', asc: true };
        }

        const tagArr = Object.keys(this.props.tags).map(tagId => this.props.tags[tagId]); // object to array
        const selectedTag = !!this.state.selectedTagId ? this.props.tags[this.state.selectedTagId] : null;

        return (
            <div className={this.props.className}>
                <h2 className="large-heading-regular margin-bottom-lg">
                    {Strings['en'].act_meta_tags.CATEGORY}: <strong className="font-weight-bold">{this.props.category.display_name}</strong>
                </h2>
                <ul className="metaTagEditorCategoryDesc">
                    {(this.props.category.type === Globals.activity_meta_tag.category_type.FREE_FORM) &&
                        <li>{Strings['en'].act_meta_tags.CATEGORY_FREE_FORM_TYPE_DESC}</li>
                    }
                    {(this.props.category.type === Globals.activity_meta_tag.category_type.ORG_CONTROLLED) &&
                        <li>{Strings['en'].act_meta_tags.CATEGORY_ORG_CONTROLLED_TYPE_DESC}</li>
                    }
                    {(this.props.category.allow_multiple) ?
                        <li>{Strings['en'].act_meta_tags.CATEGORY_ALLOW_MULT_DESC}</li>
                        :
                        <li>{Strings['en'].act_meta_tags.CATEGORY_DISALLOW_MULT_DESC}</li>
                    }
                </ul>
                <ErrorBox error={this.state.addTagError} />
                <ErrorBox error={this.state.deleteTagError} />
                <Form className="margin-bottom-lg">
                    <Form.Group controlId={`add-act-meta-tag-${this.props.category.id}`}>
                        <Form.Label>{Strings['en'].act_meta_tags.TAG_NAME}</Form.Label>
                        <InputGroup>
                            <Form.Control
                                value={this.state.newTag}
                                onChange={this.onUpdateNewTag}
                            />
                            <InputGroup.Append>
                                <Button 
                                    disabled={!this.state.newTag}
                                    onClick={this.onAddTag}
                                >
                                    {Strings['en'].common.ADD}
                                </Button>
                            </InputGroup.Append>
                        </InputGroup>
                    </Form.Group>
                </Form>

                <div className="margin-bottom-lg">
                    <ExpandableWell title="Import/Export">
                        <div className="margin-top-lg margin-bottom-xl">
                            <h3 className="md-heading margin-bottom-lg">Export Tags</h3>
                            <ExportTagsInfo
                                className="font-size-14px margin-bottom-lg line-height-16px"
                                categoryName={this.props.category.display_name}
                                requiresOrder={this.props.category.requires_order}
                            />
                            <div className="text-centered">
                                <a className="link-plain btn btn-primary d-inline-block" href={this.getExportCsvHref()}>
                                    {Strings['en'].common.EXPORT_CSV}
                                </a>
                            </div>
                        </div>
                        <div>
                            <h3 className="md-heading margin-bottom-lg">Import Tags</h3>
                            <ImportTagsInfo
                                className="font-size-14px margin-bottom-lg line-height-16px"
                                categoryName={this.props.category.display_name}
                                requiresOrder={this.props.category.requires_order}
                            />
                            {!this.props.orgActMetaImportChanges ?
                                <div>
                                    <ErrorBox error={this.state.importTagsError} />
                                    <div className="text-centered">
                                        <SingleAssetInput
                                            buttonOnly
                                            browseText="Import CSV"
                                            assetType="csv"
                                            assetRole="tags"
                                            accept="text/csv, .csv"
                                            disabled={!!this.props.orgActMetaImportChanges}
                                            onChange={this.importCsv}
                                            onError={(err) => {console.log(err)}}
                                            validateAssetType={AssetUtil.validateCsvMimeType}
                                        />
                                    </div>
                                    
                                </div>
                                :
                                <div className="bg-color-white padding-all-md">
                                    <h3 className="sm-heading margin-bottom-lg">Pending Changes From Import</h3>
                                    <div className="sub-heading">
                                        The imported changes have not yet been finalized. Please review and click 'Confirm Changes' to finalize.
                                    </div>
                                    <OrgActMetaTagImportChanges className="border-all-warn padding-all-md" orgId={this.props.orgId} categoryId={this.props.category.id} category={this.props.category} />
                                </div>
                            }
                        </div>
                    </ExpandableWell>

                </div>

                <SortableTableClassic
                    classNameTableContainer="margin-bottom-lg"
                    onRowClick={this.onActiveTagClick}
                    rows={tagArr}
                    selectedRowKey={this.state.selectedTagId}
                    dateFormat="YYYY-MM-DD HH:mm z"
                    defaultSort={defaultSort}
                    tableHeight={500}
                    columns={tableColumns}
                />

                {(!!selectedTag) &&
                    <div>
                        <ErrorBox error={this.state.updateTagError} />
                        <ErrorBox error={this.state.reorderTagError} />
                        <OrgActMetaTagEditor
                            className="margin-top-xl"
                            orgId={this.props.orgId}
                            category={this.props.category}
                            tagRecord={selectedTag}
                            onDelete={this.setConfirmDeleteTagModalState.bind(this, true, selectedTag)}
                            onUpdate={this.onUpdateTag.bind(this, selectedTag)}
                            onReorder={this.onReorder.bind(this, selectedTag)}
                            onClose={this.onDeselectTag}
                            maxDisplayOrder={tagArr.length - 1}
                        />
                    </div>
                }

                {(this.state.confirmDeleteTagModal) &&
                    <ConfirmModal
                        show={this.state.confirmDeleteTagModal}
                        modalTitle="Delete Tag"
                        text={
                            <DeleteTagWarning
                                className="margin-top-sm font-weight-bold text-centered font-size-14px"
                                attachedActCount={this.state.tagToDelete.usage_count}
                            />
                        }
                        buttonText="confirm delete"
                        confirmButtonBsStyle="danger"
                        confirmHandler={this.onDeleteTag.bind(this, this.state.tagToDelete.id)}
                        cancelButtonText="cancel"
                        cancelHandler={this.setConfirmDeleteTagModalState.bind(this, false)}
                        closeHandler={this.setConfirmDeleteTagModalState.bind(this, false)}
                    />
                }
            </div>
        );
    }
}

OrgActMetaTagCategoryEditor.propTypes = propTypes;
OrgActMetaTagCategoryEditor.defaultProps = defaultProps;

export default WithOrganizationActivityMetaTagImportChanges(OrgActMetaTagCategoryEditor);